import { api } from '@setplex/tria-api'
import { combine, type Store } from 'effector'

import { model as i18n } from '!/i18n'

import type { EventWithPrice } from '@/interfaces'
import { formatLiveEventWithPrice } from './helpers'

export const $liveUpcomingEventsFormatted: Store<EventWithPrice[]> =
  api.liveEvents.$liveUpcominEvents.map((events) =>
    events.map(formatLiveEventWithPrice)
  )

export const $liveUpcomingEventsCategory = combine(
  $liveUpcomingEventsFormatted,
  api.liveEvents.$liveUpcomingEventsPageInfo,
  i18n.$t,
  (liveEvents, pageInfo, { t }) => {
    return {
      content: liveEvents,
      name: t('event_other'),
      isMoreThanOnePage: !pageInfo?.last,
    }
  }
)
